import Axios from "axios";
import {
  SET_BONUS_TREND_REPORT_LIST,
  UNSET_BONUS_TREND_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getBonusTrendReport,
} from "@/store/api";

const state = {
  getBonusTrendReport: [],
};

const getters = {
  getBonusTrendReport(state) {
    return state.getBonusTrendReport;
  },
};

const mutations = {
  [SET_BONUS_TREND_REPORT_LIST](state, data) {
    state.getBonusTrendReport = data;
  },
  [UNSET_BONUS_TREND_REPORT_LIST](state) {
    state.getBonusTrendReport = [];
  },
};

const actions = {
  getBonusTrendReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getBonusTrendReport}`, { params: data })
        .then((response) => {
          commit(SET_BONUS_TREND_REPORT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_BONUS_TREND_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

